import React, {useEffect, useRef, useState} from "react";
import classes from "../AdminTools.module.css";
import {executeAction} from "../../../../api/dataCollection/dataCollection-service";
import {Menu} from "primereact/menu";
import {Button} from "primereact/button";


const DynamicActions = ({actions, dataCollection, visible, disabled, fetchActions}) => {
    const [actionInProgress, setActionInProgress] = useState(false);
    const splitButtonRef = useRef(null);


    useEffect(() => {
        const interval = setInterval(() => {
            if (actionInProgress)
                fetchActions().then((fetched) => {
                    if (!fetched) setActionInProgress(false)
                })
        }, 5000)
        return () => clearInterval(interval);
    }, [actionInProgress]);

    const createMenuItems = () => {
        return actions
            .map((action) => ({
                    id: action.id,
                    label: action.label,
                    executionStatus: action.executionStatus,
                    icon: action?.executionStatus === "IN_PROGRESS" ? 'pi pi-spin pi-spinner' : action?.executionStatus === "COMPLETED" ? "pi pi-download" : 'pi pi-file-export',
                    disabled: action?.executionStatus === "IN_PROGRESS",
                    command: async () => {
                        await handleAction(action);
                        setDcActions(prevActions => prevActions.map(prevAction =>
                            prevAction.id === action.id ? {
                                ...prevAction,
                                executionStatus: "COMPLETED",
                                icon: "pi pi-download",
                                disabled: false
                            } : prevAction))
                    }
                })
            );
    };

    const [dcActions, setDcActions] = useState(createMenuItems())

    useEffect(() => {
        const currentDcActions = createMenuItems()
        setDcActions(currentDcActions)
    }, [actions]);

    useEffect(() => {
        setActionInProgress(dcActions.filter(dcAction => dcAction.executionStatus === "IN_PROGRESS")?.length > 0)
    }, [dcActions]);


    const handleAction = async (action) => {
        setDcActions(prevActions => prevActions.map(prevAction =>
            prevAction.id === action.id ? {
                ...prevAction,
                executionStatus: "IN_PROGRESS",
                icon: "pi pi-spin pi-spinner",
                disabled: true
            } : prevAction
        ));
        await executeAction(action.id, dataCollection.id)
    };


    return actions.length > 0 ? (
            <>
                <Menu
                    ref={splitButtonRef}
                    model={dcActions}
                    popup
                />

                <Button
                    iconPos={"right"}
                    icon=""
                    label=""
                    visible={visible}
                    disabled={disabled}
                    className={classes.splitBtn}
                    onClick={(event) => splitButtonRef.current?.toggle(event)}
                >
                    <div style={{display: 'flex', alignItems: 'center', gap: "8px"}}>
                        <i className={actionInProgress ? "pi pi-spinner pi-spin" : "pi pi-file-export"}/>
                        <span className={"p-button-label p-c"}>Execute Actions</span>
                        <i className="pi pi-angle-down"/>
                    </div>
                </Button>
            </>

        ) :
        <></>
}

export default DynamicActions;
